module.exports = __webpack_public_path__ + "static/media/matalizado-e-selavel-350x210.f4b533cc.jpg";